/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Resource assignment delete info
 */
import { ValidateUtils } from 'app/shared/utils';

export class ResourceAssignmentDeleteInfo { 
    /**
     * Flag indicating whether resource assignment can be deleted without warning or not
     */
    readonly warnOnDelete?: boolean;

    constructor(item?: Partial<ResourceAssignmentDeleteInfo>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            warnOnDelete: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.warnOnDelete : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ResourceAssignmentDeleteInfo.isValid,
        };
    }

    static isValid(obj: ResourceAssignmentDeleteInfo): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ResourceAssignmentDeleteInfo.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.warnOnDelete.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

